<template>
  <div style="height: 100%">
    <Header :title="headerStyle.toolbarAgentName" :isBack="true" :isHistory="false"></Header>

    <div class="chatCon" style="background-color: rgb(229, 232, 242)">
      <div class="msgCon">
        <!--  msgBox -->

        <div class="msgBox">
          <HistoryMsgList
            ref="scrollList"
            class="msgList"
            :messages="messages"
            :scenarioCheckData="scenarioCheckData"
            :chatRoomId="chatRoomId"
          ></HistoryMsgList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helpers from '@/util/helpers';
import HistoryMsgList from '../webChat/components/HistoryMsgList';
import Header from '@/components/Header';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'historyDetail',
  components: {
    Header,
    HistoryMsgList
  },
  computed: {
    ...mapGetters(['chatRoomData'])
  },
  data() {
    return {
      headerStyle: {},
      senderUid: window.localStorage.getItem(process.env.VUE_APP_LOGIN_ID)
        ? window.localStorage.getItem(process.env.VUE_APP_LOGIN_ID)
        : window.localStorage.getItem(process.env.VUE_APP_UUID_KEY),
      currentlyChatRoom: window.sessionStorage.getItem('CURRENTLY_CHATROOM') ? JSON.parse(window.sessionStorage.getItem('CURRENTLY_CHATROOM')) : {},
      chatRoomId: 0,
      agentName: '',
      roomList: [],
      newMessage: false,
      lastMessage: '',
      messages: [],
      currentPage: 1,
      totalPages: 1,
      scrollInit: true,
      elm: null,
      scenarioCheckData: {}
    };
  },
  created() {
    this.chatRoomId = this.$route.query.chatRoomId;
  },
  mounted() {
    this.headerStyle = this.chatRoomData.headerStyle;
    window.$mitt.on('subscribeBody', this.subscribeBody);
    this.getMessagesList();
    this.elm = document.querySelector('.msgList');
    this.elm.addEventListener('scroll', this.scrollListener);
  },
  methods: {
    ...mapMutations(['setChatRoomData', 'setMessagesData']),
    subscribeBody(body) {
      switch (body.changeType) {
        case 'NEW_CHAT_MESSAGE':
          if (body.data.chatRoomId === this.currentlyChatRoom.id) {
            if (this.chatRoomData.messagesData.length > 0) {
              this.setMessagesData(this.chatRoomData.messagesData.concat(body.data));
            }
          }
          break;
        case 'CLOSE_CHAT_ROOM':
          if (body.data.chatRoomId === this.currentlyChatRoom.id) {
            this.setChatRoomData({
              chatRoomId: null,
              isEnd: true,
              headerStyle: this.chatRoomData.headerStyle,
              showInput: false,
              messagesData: this.chatRoomData.messagesData
            });
          }
          break;
      }
    },
    scrollListener() {
      if (this.scrollInit && this.elm.scrollTop + this.elm.clientHeight + 800 >= this.elm.scrollHeight && this.currentPage < this.totalPages) {
        this.currentPage = this.currentPage + 1;
        this.getMessagesList();
      }
    },
    printCreateMessageDate(datetimeString) {
      return helpers.printTimeStampMessageFromDate(datetimeString);
    },
    getMessagesList() {
      this.scrollInit = false;
      this.$http({
        method: 'GET',
        url: `/api/external/chat/${this.chatRoomId}/messages`,
        params: {
          page: this.currentPage,
          size: 50,
          userKey: this.senderUid,
          brandKeyEncrypt: JSON.parse(window.sessionStorage.getItem('BRAND_QUERY')).brandKey
        }
      }).then((result) => {
        const res = result.data;
        if (res.code !== 0) {
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message: '<dl class="txt"><dd>' + res.message + '</dd></dl>'
          });
        } else {
          this.currentPage = res.currentPage;
          this.totalPages = res.totalPages;
          let checkIndex = 1;
          res.data.forEach((message, idx) => {
            if (message.messageType === 'BROWSER_EXIT') {
              checkIndex = checkIndex + 1;
              return false;
            }

            let content = JSON.parse(message.content);
            if (message.messageType === 'SCENARIO' || message.messageType === 'COMBINATION') {
              if (content.code) {
                this.scenarioCheckData[idx - checkIndex] = content.code;
              }
            }
            message.isAiBotIcon = content.isBotAgentConnect ? content.isBotAgentConnect : false;
            this.pushMessage(message, idx);
          });
          this.scrollInit = true;
          setTimeout(() => {
            this.scrollListener();
          });
        }
      });
    },
    pushMessage(message) {
      if (message.createDate === undefined) {
        message.createDate = this.$moment().format('YYYYMMDDHHmmss');
      }
      this.messages.push({
        id: message.id,
        senderType: message.senderType,
        senderName: message.senderName,
        messageType: message.messageType,
        content: message.content,
        channelName: message.channelName,
        createDate: message.createDate,
        isAiBotIcon: message.isAiBotIcon
      });
    }
  }
};
</script>
